import CardDesignerCardSide from './CardDesignerCardSide';

export default CardDesignerCardSide;
